// src/components/Header.js
import React from 'react';
import './Header.css'; // Import the CSS file for styling
import logo from '../../assets/bonzai_logo_v2.png'; // Make sure the path is correct
import { Link } from 'react-scroll';

function Header() {
  return (
    <header className="header">
      <div className="header-brand">
        <img src={logo} alt="Logo" className="header-logo" />
        <h1>
          <span className="bonzai">BonzAI</span>
          {' '}
          <span className="crystallization">Protein Crystallization</span>
        </h1>
      </div>
      <nav className="navbar">
        <ul>
            <li><Link to="Home" spy={true} smooth={true} duration={500}>Home</Link></li>
            <li><Link to="About" spy={true} smooth={true} duration={500}>About</Link></li>
            <li><Link to="Pricing" spy={true} smooth={true} duration={500}>Pricing</Link></li>
            <li><Link to="Contact" spy={true} smooth={true} duration={500}>Contact</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
